import { Accordion, AccordionDetails, AccordionSummary, Avatar, Box, Breadcrumbs, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Fab, FormControlLabel, Grid, IconButton, InputAdornment, LinearProgress, List, ListItem, Popover, Slide, Stack, Switch, TextField, Tooltip, Typography } from '@mui/material';
import PageLayout from '../../components/PageLayout';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteRequest, getRequest, postRequest, putRequest } from '../../utils/ApiUtil';
import { setPageMessage, setProcessing } from '../../store/ApplicationStore';
import { apiEndpoints, appConfigs, appRoutes } from '../../constants/ApplicationConstants';
import { addToActiveChat, clearActiveChat, clearActiveChatId, deleteThreadInStore, editThreadInStore, storeActiveChat, storeActiveChatId, storeThreads, updateConversationFeedback } from '../../store/ThreadStore';
import ChatSerializer from '../../serializers/ChatSerializer';
import { CheckCircleOutline, Close, ContentCopy, Delete, Edit, ExpandMore, InfoOutlined, KeyboardDoubleArrowDown, KeyboardDoubleArrowLeft, KeyboardDoubleArrowRight, KeyboardDoubleArrowUp, NavigateNext, Send, ThumbDownAlt, ThumbDownOffAlt, ThumbUpAlt, ThumbUpOffAlt } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import { saveSelectedProcessToStore, saveSelectedSubProcessToStore } from '../../store/UserMenuStore';
import ThreadSerializer from '../../serializers/ThreadSerializer';
import chatlogo from '../../assets/images/genpactlogo.svg';
import newChatImage from '../../assets/images/new-chat-icon.svg';
import { pageMessages } from '../../constants/MessageConstants';
import { useHandleError } from '../others/ErrorScreen';
import DocViewer from '../../components/DocViewer';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Remarkable } from 'remarkable';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function ChatScreen(){
    const { user, muiTheme } = useSelector(state => state.user)
    const { threads, activeChat, activeChatId } = useSelector(state => state.chat);
    const { selectedSubProcess, menu, selectedDomain, selectedProcess } = useSelector(state => state.menu);
    const [ questionType, setQuestionType ] = useState(appConfigs.questionTypes.default);
    const [ leftPanelExpanded, setLeftPanelExpanded ]= useState(true);
    const [ selectedThread, setSelectedThread ] = useState(null);
    const [ showThreadOptions, setShowThreadOptions ] = useState(null);
    const [ showThreadEdit, setShowThreadEdit] = useState(false);
    const [ threadName, setThreadName] = useState("");
    const [ threadCharCount, setThreadCharCount] = useState(appConfigs.threadCharCount);
    const [ showThreadDelete, setShowThreadDelete] = useState(false)
    const [ showFeedbackPop, setShowFeedbackPop ] = useState(false); 
    const [ feedback, setFeedback ] = useState(null);
    const [ selectedConversation, setSelectedConversation ] = useState(null);
    const [ feedbackComment, setFeedbackComment ] = useState(null);
    const [ feedbackCategory, setFeedbackCategory ] = useState(null);
    const [ feedbackCharCount, setFeedbackCharCount ] = useState(appConfigs.feedbackCharCount); 
    const [ query, setQuery ] = useState("");
    const [ postedQuestion, setPostedQuestion ] = useState(null);
    const [ streamedAnswer, setStreamedAnswer ] = useState("");
    const [ showChatLoader, setShowChaTLoader ]= useState(null);
    const [ faqs, setFaqs ]= useState(questionType==='QnA'?menu?.find((item)=>item.id===selectedSubProcess)?.qnaFaqs?.faq:menu?.find((item)=>item.id===selectedSubProcess)?.docsearchFaqs?.faq); 
    const [ hoveredFaq, setHoveredFaq ]= useState(null);
    const [copied, setCopied]= useState(null);

    const [ showDocumentViewer, setShowDocumentViewer ] = useState(false);
    const [ documentObject, setDocumentObject ] = useState(null);
    const [ selectedImageChatId, setSelectedImageChatId ] = useState(null);

    const dispatch= useDispatch();
    const navigate= useNavigate();
    const divRef= useRef(null);
    const handleError=useHandleError();
    const remark= new Remarkable();

    useEffect(() => {
        divRef.current.scrollTop= divRef.current.scrollHeight+10
    },[activeChat,streamedAnswer,postedQuestion])

    const fetchThreads = useCallback(async()=>{
        try{
            dispatch(setProcessing(true));
            const response= await getRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.threads+"/"+selectedSubProcess);
            if(response.isError){
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: response.message, type: "error"}));
            }else{
                const fetchedThreads= response.data&&response.data.map((thread)=>{
                    return ChatSerializer(thread)
                }).filter(obj=>obj)
                dispatch(storeThreads(fetchedThreads));
                dispatch(setPageMessage({message: response.message, type: "success"}));
                dispatch(setProcessing(false))
            }
        }
        catch(err)
        {
            handleError(err)
        }
       
    },[dispatch, selectedSubProcess,handleError])
    useEffect(()=> {
        if(!threads){
            if(selectedSubProcess){
                fetchThreads();
            }else{
                navigate(appRoutes.menu);
            }
        }
    }, [dispatch, navigate, selectedSubProcess, threads, fetchThreads])
    useEffect(() => {
        if (copied) {
          const timer = setTimeout(() => {
            setCopied(null);
          }, 1500);
    
          return () => clearTimeout(timer);
        }
      }, [copied]);
    function handleNewChat(){
        try{
            dispatch(clearActiveChat());
            dispatch(clearActiveChatId()); setQuestionType(appConfigs.questionTypes.default);
            setPostedQuestion(null); setQuery(""); setStreamedAnswer(null);
            setFaqs(questionType==='QnA'?menu?.find((item)=>item.id===selectedSubProcess)?.qnaFaqs?.faq:menu?.find((item)=>item.id===selectedSubProcess)?.docsearchFaqs?.faq);
    
        }catch(err){
            handleError(err)
        }
    }
    function handleLeftPanelToggle(){
        setLeftPanelExpanded(!leftPanelExpanded)
    }
    async function handleThreadSelection(id){
        try{
            dispatch(setProcessing(true));
            const response= await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.threadDetails, {
                thread_id: id,
                menu_id: selectedSubProcess,
                count: appConfigs.conversationLength
            });
            if(response.isError){
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: response.message, type: "error"}));
            }else{
                const fetchedThreadDetail= response.data&&response.data.map((thread)=>{
                    return ThreadSerializer(thread)
                }).filter(obj=>obj)
                dispatch(storeActiveChat(fetchedThreadDetail)); 
                dispatch(storeActiveChatId(id));
                dispatch(setPageMessage({message: response.message, type: "success"}));
                dispatch(setProcessing(false))
            }
        }catch(err){
            handleError(err)
        }
    }
    function handleThreadEdit(thread){
        if(showThreadEdit){
            setSelectedThread(null); setShowThreadEdit(false); setThreadName(""); setThreadCharCount(appConfigs.threadCharCount);
        }else{
            setSelectedThread(thread); setShowThreadEdit(true); 
            if(thread)
            {
                let name=''
                if(thread.threadName && thread.threadName.length > 50)
                {
                    name=thread.threadName.substring(0, 50);
                }
                else if(thread.threadName)
                {
                     name=thread.threadName
                }              
                setThreadName(name);
            }      
        }
    }
    function handleThreadDelete(thread){
        if(showThreadDelete){
            setSelectedThread(null); setShowThreadDelete(false);
        }else{
            setSelectedThread(thread); setShowThreadDelete(true);
        }
    }
    async function handleEditSubmit(){
        try{
            dispatch(setProcessing(true));
        if(threadName.trim() !== ""){
                const response= await putRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.editThread, {
                    thread_id: selectedThread.id,
                    thread_name: threadName
                });
                if(response.isError){
                    setSelectedThread(null); setShowThreadEdit(false); setThreadName(""); setThreadCharCount(appConfigs.threadCharCount);
                    dispatch(setProcessing(false));
                    dispatch(setPageMessage({message: response.message, type: "error"}));
                }else{
                    dispatch(editThreadInStore(ChatSerializer({...selectedThread, name: threadName})));
                    setSelectedThread(null); setShowThreadEdit(false); setThreadName(""); setThreadCharCount(appConfigs.threadCharCount);
                    dispatch(setPageMessage({message: response.message, type: "success"}));
                    dispatch(setProcessing(false))
            }
        }else{
            dispatch(setProcessing(false));
            dispatch(setPageMessage({message: "Please enter a valid thread name.", type: "error"}));
            }
        }catch(err){
            handleError(err)
        }
       
    }
    async function handleDeleteSubmit(){
        try{
            dispatch(setProcessing(true));
            const response= await deleteRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.deleteThread+"/"+selectedThread.id);
            if(response.isError){
                setSelectedThread(null); setShowThreadDelete(false);
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: response.message, type: "error"}));
            }else{
                dispatch(deleteThreadInStore(selectedThread.id));
                setSelectedThread(null); setShowThreadDelete(false);
                dispatch(clearActiveChat()); dispatch(clearActiveChatId())
                dispatch(setPageMessage({message: response.message, type: "success"}));
                dispatch(setProcessing(false))
            }
        }catch(err){
            handleError(err)
        }
       
    }
    function handleSubProcessSelection(subprocess){
        if(subprocess)
        {
            dispatch(saveSelectedProcessToStore(subprocess.parent));
            dispatch(saveSelectedSubProcessToStore(subprocess.id)); setQuestionType(appConfigs.questionTypes.default);
            dispatch(storeThreads(null)); dispatch(clearActiveChat()); dispatch(clearActiveChatId());
            setFaqs(appConfigs.questionTypes.default==='QnA'?menu?.find((item)=>item.id===subprocess.id)?.qnaFaqs?.faq:menu?.find((item)=>item.id===subprocess.id)?.docsearchFaqs?.faq);
        
        }
    }
      
    function handleFeedbackToggle(flag, selection){
        if(showFeedbackPop){
            setShowFeedbackPop(false); setFeedback(null); setSelectedConversation(null); setFeedbackComment(null); setFeedbackCategory(null); setFeedbackCharCount(appConfigs.feedbackCharCount);
        }else{
            setShowFeedbackPop(true); setFeedback(flag); setSelectedConversation(selection); setFeedbackCategory(null); setFeedbackComment(null);setFeedbackCharCount(appConfigs.feedbackCharCount);
        }
    }
    async function handleFeedbackSubmit(){
        try{
            dispatch(setProcessing(true));
            const response= await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.feedback, {
                user_feedback_comment: feedbackComment,
                user_feedback: feedback ,
                question_id: selectedConversation.questionId,
                category: feedbackCategory
            });
            if(response.isError){
                setShowFeedbackPop(false); setFeedback(null); setSelectedConversation(null); setFeedbackComment(null); setFeedbackCategory(null);
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: response.message, type: "error"}));
            }else{
                dispatch(updateConversationFeedback({questionId: selectedConversation.questionId, feedback: feedback, category: feedbackCategory, comment: feedbackComment}));
                setShowFeedbackPop(false); setFeedback(null); setSelectedConversation(null); setFeedbackComment(null); setFeedbackCategory(null);
                dispatch(setPageMessage({message: response.message, type: "success"}));
                dispatch(setProcessing(false))
            }
        }catch(err){
            handleError(err)
        }
       
    }
    function replaceLineEnds(obj){
        if(obj){
            return obj.replace(/<br>+/g,"")
        }
        return "";
    }
    function generateText(obj){
        let text=""
        if(obj && obj.question){    
          text+=replaceLineEnds(obj.question)+"\n"
        }
        if(obj && obj.answer){
          text+=replaceLineEnds(obj.answer)+"\n"
        }
        return text
    }
    function handlePostQuestion(){
        try{
            setShowChaTLoader(true);
            var encodedQuestion = new URLSearchParams();
            encodedQuestion.set('question',query);
            encodedQuestion.toString();
            if(query.trim()===""){
                dispatch(setPageMessage({message: pageMessages.invalidQuestion, type: "error"}));
                setShowChaTLoader(false);
            }else{
                let streamData = null;
                setPostedQuestion(query);
                setQuery("");
                return new Promise((resolve, reject) => {     
                    const eventSource = new EventSource(activeChatId ?  apiEndpoints.backendBaseURL+apiEndpoints.question+`?sub_process_id=${selectedSubProcess}&${encodedQuestion}&query_type=FullText&thread_id=${activeChatId}&doc_search=${questionType!=="QnA"}&token=${user.accessToken}`
                        :  apiEndpoints.backendBaseURL+apiEndpoints.question+`?sub_process_id=${selectedSubProcess}&${encodedQuestion}&query_type=FullText&doc_search=${questionType!=="QnA"}&token=${user.accessToken}`
                    );
                    eventSource.onmessage = (event) => {
                        const newMessage = event.data;
                        try {
                            streamData=JSON.parse(newMessage);        
                        }catch (error) { 
                            setStreamedAnswer((prev) => {
                                if(newMessage.toString().trim().toUpperCase() === "SOURCES_COST_INCOMING" || newMessage.toString().trim().toUpperCase() === "RETRIEVER_UTILIZED"){
                                    if(prev){return prev + ""}else{return ""}
                                }else{
                                    if(prev){return prev + newMessage.toString()}else{return newMessage.toString()}
                                }
                            });
                        }                                 
                    };
                    eventSource.onerror = (error) => {  
                        eventSource.close();
                        resolve(streamData);
                        const streamedThread= streamData&&ThreadSerializer(streamData);
                        streamedThread&&dispatch(addToActiveChat(streamedThread));
                        streamedThread&&dispatch(storeActiveChatId(streamedThread.threadId));
                        fetchThreads(); setShowChaTLoader(false);
                        setPostedQuestion(null); setQuery(""); setStreamedAnswer(null);
                    };    
                }) 
            }
        }catch(err){
            setShowChaTLoader(false);
            handleError(err)
        }
      
    }
    function handleFAQQuestion(faq){
        try{
            setShowChaTLoader(true);
            const postedQuery= faq;
            var encodedQuestion = new URLSearchParams();
            encodedQuestion.set('question',postedQuery);
            encodedQuestion.toString();
            if(faq.trim()===""){
                dispatch(setPageMessage({message: pageMessages.invalidQuestion, type: "error"}));
                setShowChaTLoader(false);
            }else{
                let streamData = "";
                setPostedQuestion(faq);
                setQuery("");
                return new Promise((resolve, reject) => {     
                    const eventSource = new EventSource(activeChatId ?  apiEndpoints.backendBaseURL+apiEndpoints.question+`?sub_process_id=${selectedSubProcess}&${encodedQuestion}&query_type=FullText&thread_id=${activeChatId}&doc_search=${questionType!=="QnA"}&token=${user.accessToken}`
                        :  apiEndpoints.backendBaseURL+apiEndpoints.question+`?sub_process_id=${selectedSubProcess}&${encodedQuestion}&query_type=FullText&doc_search=${questionType!=="QnA"}&token=${user.accessToken}`
                    );
                    eventSource.onmessage = (event) => {
                        const newMessage = event.data;
                        try {
                            streamData=JSON.parse(newMessage);        
                        }catch (error) { 
                            setStreamedAnswer((prev) => {
                                if(newMessage.toString().trim().toUpperCase() === "SOURCES_COST_INCOMING" || newMessage.toString().trim().toUpperCase() === "RETRIEVER_UTILIZED"){
                                    if(prev){return prev + ""}else{return ""}
                                }else{
                                    if(prev){return prev + newMessage.toString()}else{return newMessage.toString()}
                                }
                            });
                        }                                
                    };
                    eventSource.onerror = (error) => {  
                        eventSource.close();
                        resolve(streamData);
                        const streamedThread= streamData&&ThreadSerializer(streamData);
                        streamedThread&&dispatch(addToActiveChat(streamedThread));
                        streamedThread&&dispatch(storeActiveChatId(streamedThread.threadId));
                        fetchThreads(); setShowChaTLoader(false);
                        setPostedQuestion(null); setQuery(""); setStreamedAnswer(null);
                    };    
                }) 
            }
        }catch(err){
            setShowChaTLoader(false);
            handleError(err)
        }
      
    }

    const base64ToBlob = (base64String) => {
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: `application/pdf` });
    }

    async function handleFileExplorer(path, page, image){
        try{
            dispatch(setProcessing(true));
            const response= await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.loadDocument, {"file_path": path});
            if(response.isError){
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: response.message, type: "error"}));
            }else{
                const blob = image ? response.data : base64ToBlob(response.data);
                const blobUrl = image ? response.data : URL.createObjectURL(blob);
                page ? setDocumentObject(blobUrl+"#page="+page) : setDocumentObject(blobUrl);
                image ? setShowDocumentViewer(false) : setShowDocumentViewer(true);
                dispatch(setPageMessage({message: response.message, type: "success"}));
                dispatch(setProcessing(false))
            }
        }
        catch(err){
            handleError(err)
        }    
    }

    return (
        <PageLayout header nogutter>
            <Box>
                <Grid container spacing={2}  sx={{ flexGrow: 1,   pointerEvents: showChatLoader ? 'none' : 'auto', }}>
                    <Grid item xs={12} sm={12} md={leftPanelExpanded ? 2.3 : 1.5} sx={leftPanelExpanded ? {backgroundColor: 'secondary.main', height: 'calc(100vh - 4rem)'} : null}>
                    {leftPanelExpanded ? <Box paddingLeft={2}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Button sx={{ textTransform: 'capitalize' ,padding:'5px !important' ,boxShadow: '0px 1px 9px #00000015',border: '0.5px solid #E5E2E2',borderRadius: '4px', color: (theme)=>theme.palette.secondary.contrastText, width: '65%', marginLeft: '1rem',fontWeight:300, '&:hover':{borderColor:'#E5E2E2'} }} onClick={()=>handleNewChat()} variant="outlined" ><img src={newChatImage} alt='' style={{marginRight:'0.7rem'}}></img>New Chat</Button>
                                    <Fab onClick={()=> handleLeftPanelToggle()} size="small"  sx={{float: 'right', marginRight: '-1rem', borderRadius: '3px',  background:'#416574' ,width: 25, height: 10,   '&:hover': {backgroundColor: '#416574'
                                        }}}><KeyboardDoubleArrowLeft sx={{color:'#FFFFFF'}} /></Fab>
                                </Grid>
                                <Grid item xs={12} sx={{borderBottom: '1px solid', borderColor: '#8EB4C3', height: 'calc(100vh - 17rem)', overflow: 'auto', '&::-webkit-scrollbar': {
                                        width: '8px'
                                    },
                                    '&::-webkit-scrollbar-track': {
                                        background: 'transparent'
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        backgroundColor: 'rgba(0, 0, 0, 0.1)',
                                        borderRadius: '10px',
                                        border: '2px solid transparent',
                                        backgroundClip: 'content-box'
                                    }}}>
                                    <Box>
                                        <Typography variant='subtitle2'  sx={{color: (theme) => theme.palette.secondary.contrastText, paddingX: '1rem',opacity:0.5}}>Recent Q&A</Typography>
                                        <List>
                                                {threads&&threads.map((thread)=>{
                                                    return <ListItem key={thread.id}  disableGutters sx={{cursor: "pointer", paddingX: '1rem' }} onMouseEnter={()=>setShowThreadOptions(thread)} onMouseLeave={()=>setShowThreadOptions(null)}>
                                                                <Grid container spacing={1} sx={{'&:hover': {background:'#85ADBC',borderRadius:'8px 8px 8px 8px',paddingX:'5px'},background:activeChatId===thread.id?'#85ADBC':'',borderRadius:activeChatId===thread.id?'8px 8px 8px 8px':'',paddingX:'5px'}}>
                                                                    <Grid item xs={2}><ChatBubbleOutlineIcon sx={{ opacity: "0.5", color: (theme) => theme.palette.secondary.contrastText }} /></Grid>
                                                                    <Grid item xs={6}><Tooltip title={thread.threadName}><Typography sx={{color: (theme) => theme.palette.secondary.contrastText, textOverflow: 'ellipsis', overflow: 'hidden'}} onClick={()=>handleThreadSelection(thread.id)} noWrap >{thread.threadName}</Typography></Tooltip></Grid>
                                                                    <Grid item xs={4}>
                                                                        <Box sx={(!showThreadOptions || !(showThreadOptions&&showThreadOptions.id===thread.id))?{display: 'none'}:{textAlign:'right'}}>
                                                                            <Edit onClick={()=>handleThreadEdit(thread)} sx={{ opacity: "0.5", color: (theme) => theme.palette.secondary.contrastText}} />
                                                                            <Delete onClick={()=>handleThreadDelete(thread)} sx={{ marginLeft: '0.3rem', opacity: "0.5", color: (theme) => theme.palette.secondary.contrastText}}/>
                                                                        </Box>
                                                                    </Grid>
                                                                </Grid>
                                                            </ListItem>
                                                })}
                                        </List>
                                    </Box>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box>
                                        <List dense={true}>
                                        {
                                            appConfigs.questionTypes.types.map((type)=>{
                                                return <ListItem key={type.type} disableGutters     sx={{
                                                    paddingY: '0rem', // Reduce padding for less vertical space
                                                    marginBottom: '0rem' // Adjust this value to control spacing between items
                                                }}>
                                                    <Grid container>
                                                        <Grid item xs={12}><FormControlLabel sx={{marginRight:'1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: (theme) => theme.palette.secondary.contrastText}} value={questionType} control={<Switch onChange={(e)=>{
                                                            setQuestionType(e.target.value === type.type ? (e.target.value === 'QnA' ? 'docsearch' : 'QnA') : type.type); 
                                                            setFaqs(type.type==='QnA'?menu?.find((item)=>item.id===selectedSubProcess)?.qnaFaqs?.faq:menu?.find((item)=>item.id===selectedSubProcess)?.docsearchFaqs?.faq);
                                                        }} checked={questionType===type.type} color="primary" />} label={type.title} labelPlacement="start" /></Grid>
                                                    </Grid>
                                                </ListItem>
                                            })
                                        }
                                        </List>
                                    </Box>
                                </Grid>
                            </Grid>
                    </Box> : 
                    <Box onClick={()=> handleLeftPanelToggle()} display='flex' alignItems='center' sx={{paddingLeft: '1rem'}}>
                            <Fab  size="small"  sx={{marginRight: '1rem',  borderRadius: '3px',  background:'#416574' ,width: 30, height: 15,'&:hover': {backgroundColor: '#416574'}}}><KeyboardDoubleArrowRight sx={{color:'#FFFFFF'}} /></Fab>
                            <Typography variant='subtitle2' sx={{fontWeight:'bold'}}>Chat History</Typography>
                    </Box>
                    }
                    </Grid>
                    <Grid item xs={12} sm={12} md={leftPanelExpanded ? 9.7 : 10.5}>
                        <Box sx={{padding:0}}>
                            <Grid container spacing={2} paddingLeft={5}>
                                <Grid item xs={12} sx={{paddingBottom: '1rem'}}>
                                    <Breadcrumbs separator={<NavigateNext fontSize="small" />}>
                                        <Typography>{menu&&selectedDomain&&menu.find((item)=> item.id===selectedDomain).name}</Typography>
                                        <PopupState variant="popover">
                                            {(popupState) => (
                                                <>
                                                    <Typography sx={{cursor: 'pointer'}} {...bindTrigger(popupState)}>{menu&&selectedProcess&&menu.find((item)=> item.id===selectedProcess).name}</Typography>
                                                    <Popover {...bindPopover(popupState)} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} transformOrigin={{ vertical: 'top', horizontal: 'center' }} >
                                                        <Grid item xs={12}>
                                                            <Grid container sx={{p:2}}>
                                                                {menu&&menu.filter(process => process.domain === selectedDomain && process.parent === selectedDomain).map((processItem)=>{
                                                                    return<Grid key={processItem.id} item xs={12}>
                                                                        <Box>
                                                                            <Typography fontWeight="bold" color="secondary">{processItem.name}</Typography>
                                                                            <List dense={false}>
                                                                                {menu.filter(subProcess => subProcess.domain === selectedDomain && subProcess.parent === processItem.id).map((subProcessItem)=>{
                                                                                    return <ListItem key={subProcessItem.id} disableGutters sx={{cursor: "pointer", '&:hover': { textShadow: '1px 1px 4px rgba(0, 0, 0, 0.5)'}, transition: 'text-shadow 0.3s ease'}} onClick={()=> handleSubProcessSelection(subProcessItem)}>
                                                                                        <Box display="flex" justifyContent="space-between">
                                                                                            <Typography>{subProcessItem.name}</Typography>
                                                                                        </Box>
                                                                                    </ListItem>
                                                                                })}
                                                                            </List>
                                                                        </Box>
                                                                    </Grid>
                                                                })}
                                                            </Grid>
                                                        </Grid>
                                                    </Popover>
                                                </>
                                                )}
                                        </PopupState>
                                        <PopupState variant="popover">
                                            {(popupState) => (
                                                <>
                                                    <Typography sx={{cursor: 'pointer'}} {...bindTrigger(popupState)}>{menu&&selectedSubProcess&&menu.find((item)=> item.id===selectedSubProcess).name}</Typography>
                                                    <Popover {...bindPopover(popupState)} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} transformOrigin={{ vertical: 'top', horizontal: 'center' }} >
                                                        {menu&&menu.filter(item=>item.parent===selectedProcess).map(obj => {
                                                            return <Box key={obj.id} display="flex" justifyContent='space-between' sx={{py:1, px:2}} onClick={()=> obj.id===selectedSubProcess ? null : handleSubProcessSelection(obj)}>
                                                                        <Typography sx={obj.id===selectedSubProcess?{fontWeight: 'bold', '&:hover': { textShadow: '1px 1px 4px rgba(0, 0, 0, 0.5)'}, transition: 'text-shadow 0.3s ease'}:{cursor: 'pointer', '&:hover': { textShadow: '1px 1px 4px rgba(0, 0, 0, 0.5)'}, transition: 'text-shadow 0.3s ease'}}>{obj.name}</Typography>
                                                                    </Box>
                                                        })}
                                                    </Popover>
                                                </>
                                                )}
                                        </PopupState>
                                    </Breadcrumbs>
                                </Grid>
                                <Grid item xs={12} ref={divRef} sx={{height: 'calc(100vh - 15rem)', overflow: 'auto','&::-webkit-scrollbar': {
                                        width: '8px'
                                    },
                                    '&::-webkit-scrollbar-track': {
                                        background: 'transparent'
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        backgroundColor: 'rgba(0, 0, 0, 0.2)',
                                        borderRadius: '10px',
                                        border: '2px solid transparent',
                                        backgroundClip: 'content-box'
                                    }}}>
                                    <>
                                        {activeChat&&activeChat.map(chat => {
                                            return <Box key={chat.questionId} sx={{paddingRight:0}}>
                                                <Grid container>
                                                    {chat && <Grid item xs={12}>
                                                        <Grid container spacing={2} sx={{my:1, py: 2, px:2}}>
                                                            <Grid item md={12} lg={1} sx={{p: '0 !important'}}>
                                                                <Avatar  variant='square' sx={{ bgcolor: 'primary.main', width:35, height: 35, borderRadius: 1 }} >{user&&user.fullname[0]}</Avatar>
                                                            </Grid>
                                                            <Grid item md={12} lg={10} sx={{p: '0 !important'}}>
                                                                <Typography sx={{py:1}} variant='subtitle1'>{chat.question}</Typography>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid  container spacing={2} sx={{py: 2, px:2}}>
                                                            <Grid item md={12} lg={1} sx={{p: '0 !important'}}>
                                                                <img  height='35px' width='35px'  alt="logo" src={chatlogo}  />
                                                            </Grid>
                                                            <Grid item md={12} lg={10} sx={{p: '0 !important'}}>
                                                                {chat.answer && chat.answer !== "" && <Box>
                                                                    <div class="markupTable" dangerouslySetInnerHTML={{ __html: remark.render(chat.answer) }} ></div>
                                                                </Box>}
                                                                { questionType === "QnA" && chat.imageSource && chat.imageSource.length > 0 &&chat.imageSource.map(((source) => {
                                                                    return <>
                                                                        {chat.questionId!==selectedImageChatId && <Typography sx={{fontWeight: 'bold', textDecoration: 'underline', cursor: 'pointer', mb:2}} color={muiTheme&&muiTheme.palette.mode==='dark'?"#FFFFFF": 'primary'} onClick={()=>{setSelectedImageChatId(chat.questionId);handleFileExplorer(source.image_url, null, true)}}>Click here to view the image</Typography> }
                                                                        {documentObject && chat.questionId===selectedImageChatId && <Typography sx={{fontWeight: 'bold', textDecoration: 'underline', cursor: 'pointer', mb:2}} color={muiTheme&&muiTheme.palette.mode==='dark'?"#FFFFFF": 'primary'} onClick={()=>{setSelectedImageChatId(null);setDocumentObject(null)}}>Hide the image</Typography> }
                                                                        {documentObject && chat.questionId===selectedImageChatId ?<img key={source.image_url} alt='' src={"data:image/png;base64,"+documentObject} /> : null}
                                                                    </>
                                                                }))}
                                                                {chat.imageSource && chat.imageSource.length > 0 && 
                                                                    <Accordion style={{width:'65%',background:'#F2F2F2'}}>
                                                                    <AccordionSummary sx={{ minHeight: '30px !important',  '&.Mui-expanded': { height: '15px !important' }}} expandIcon={<ExpandMore />}><Typography fontWeight='bold' color='black'>Image Sources</Typography></AccordionSummary>
                                                                    <AccordionDetails>
                                                                     {chat.imageSource.map(((source,index) => {
                                                                        return <Box key={"imgsources"+index}>
                                                                            <Stack direction='row' spacing={1}>
                                                                                <Typography noWrap>Document Name:</Typography>
                                                                                <Typography sx={{wordBreak: 'break-word'}} >{source.file_name}</Typography>
                                                                            </Stack>
                                                                            <Stack direction='row' spacing={1}>
                                                                                <Typography noWrap>Page:</Typography>
                                                                                <Typography sx={{ textDecoration: 'underline', cursor: 'pointer'}} color={muiTheme&&muiTheme.palette.mode==='dark'?"#FFFFFF": 'primary'} onClick={()=>handleFileExplorer(source.file_url, source.page_no, false)}>{source.page_no}</Typography>
                                                                            </Stack>
                                                                            <Typography sx={{ textDecoration: 'underline', cursor: 'pointer'}} color={muiTheme&&muiTheme.palette.mode==='dark'?"#FFFFFF": 'primary'} onClick={()=>handleFileExplorer(source.file_url, null, false)}>Click Here to View the Document</Typography>
                                                                            </Box>}))}
                                                                    </AccordionDetails>
                                                                  </Accordion>
                                                                }
                                                                {chat.textSource && chat.textSource.length > 0?
                                                                    <Accordion style={{width:'65%',background:'#F2F2F2'}}>
                                                                    <AccordionSummary  sx={{ minHeight: '30px !important',  '&.Mui-expanded': { height: '15px !important' }}} expandIcon={<ExpandMore />}><Typography fontWeight='bold' color='black'>Document Sources</Typography></AccordionSummary>
                                                                    <AccordionDetails>
                                                                     {chat.textSource.map(((source,index) => {
                                                                        return <Box key={"textsources"+index} >
                                                                        <Stack direction='row' spacing={1}>
                                                                            <Typography noWrap>Document Name:</Typography>
                                                                            <Typography sx={{wordBreak: 'break-word'}} >{source.file_name}</Typography>
                                                                        </Stack>
                                                                        <Stack direction='row' spacing={1}>
                                                                            <Typography noWrap>Pages:</Typography>
                                                                            {source.pages.map((page)=>{
                                                                                return <Typography sx={{ textDecoration: 'underline', cursor: 'pointer'}} color={muiTheme&&muiTheme.palette.mode==='dark'?"#FFFFFF": 'primary'} onClick={()=>handleFileExplorer(source.file_url, page, false)}>{page}</Typography>
                                                                            })}
                                                                        </Stack>
                                                                        <Typography sx={{ textDecoration: 'underline', cursor: 'pointer'}} color={muiTheme&&muiTheme.palette.mode==='dark'?"#FFFFFF": 'primary'} onClick={()=>handleFileExplorer(source.file_url, null, false)}>Click Here to View the Document</Typography>
                                                                      </Box>}))}
                                                                    </AccordionDetails>
                                                                  </Accordion>:<>{(!chat.answer || chat.answer==='')? <Typography>No Document Sources Available</Typography>:null}</>
                                                                }
                                                            </Grid>
                                                        </Grid>
                                                        <Grid container spacing={2} >
                                                            <Grid item xs={1}></Grid>
                                                            <Grid item xs={11}>
                                                                <Stack direction='row' spacing={3}>
                                                                    {chat.feedback ===1 ? <ThumbUpAlt onClick={()=>{handleFeedbackToggle(0, chat)}} sx={{cursor: 'pointer', opacity: 0.5}} /> : <ThumbUpOffAlt onClick={()=>{handleFeedbackToggle(1, chat)}} sx={{cursor: 'pointer', opacity: 0.5}} />}
                                                                    {chat.feedback ===2 ? <ThumbDownAlt onClick={()=>{handleFeedbackToggle(0, chat)}} sx={{cursor: 'pointer', opacity: 0.5}} /> : <ThumbDownOffAlt onClick={()=>{handleFeedbackToggle(2, chat)}} sx={{cursor: 'pointer', opacity: 0.5}} />}
                                                                    <PopupState variant="popover">
                                                                        {(popupState) => (
                                                                            <>
                                                                                <InfoOutlined sx={{cursor: 'pointer', opacity: 0.5}} {...bindTrigger(popupState)} />
                                                                                <Popover {...bindPopover(popupState)} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'center' }}  >
                                                                                    <List sx={{  paddingLeft:'1rem',paddingRight:'1.5rem', bgcolor: '#383838' }}>
                                                                                    <ListItem sx={{ padding: '0' ,color:'#fff'}}>
                                                                                        <IconButton  sx={{paddingX:'2px' }} ><InfoOutlinedIcon sx={{ color: '#fff'}} /> </IconButton> Information
                                                                                    </ListItem>
                                                                                        {chat.questionType&&<ListItem sx={{ padding: '0' ,color:'#fff',opacity:0.7,marginLeft:'15px'}}>
                                                                                        Question Type : {chat.questionType}
                                                                                        </ListItem>}
                                                                                        { (chat && chat.stream_start !== null && chat.stream_start !=='' && chat.stream_start !== undefined)   &&<ListItem sx={{ padding: '0',color:'#fff' ,opacity:0.7,marginLeft:'15px'}}>
                                                                                        Stream Start Time :   {`${chat.stream_start} s`}  
                                                                                        </ListItem>}
                                                                                        {chat.responseTime&&<ListItem  sx={{ padding: '0' ,color:'#fff',opacity:0.7,marginLeft:'15px'}}>Response Time : {`${chat.responseTime} s`} 
                                                                                        </ListItem>}
                                                                                        {chat.totalCost&&<ListItem  sx={{ padding: '0' ,color:'#fff',opacity:0.7,marginLeft:'15px'}}>Total Cost : {`$ ${chat.totalCost.toFixed(3)}`}
                                                                                        </ListItem>}
                                                                                        {chat.totalTokens&&<ListItem  sx={{ padding: '0' ,color:'#fff',opacity:0.7,marginLeft:'15px'}}>Total Tokens : {chat.totalTokens}
                                                                                        </ListItem>}
                                                                                    </List>
                                                                                </Popover>
                                                                            </>
                                                                            )}
                                                                    </PopupState>
                                                                    {chat.answer && chat.answer !== ""  &&
                                                                    <Stack direction='row' >
                                                                        <ContentCopy onClick={()=>{setCopied(chat.questionId); navigator.clipboard.writeText(generateText(chat))}} sx={{cursor: 'pointer', opacity: 0.5}} />
                                                                            { copied===chat.questionId  && !!copied &&  <Box display='flex' ><CheckCircleOutline sx={{color: 'secondary.main'}} /><Typography sx={{color: 'secondary.main'}}>Copied</Typography></Box>
                                                                        }
                                                                    </Stack>
                                                                    }
                                                                </Stack>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>}
                                                </Grid>
                                            </Box>
                                        })}
                                        {postedQuestion && <Grid container>
                                            <Grid item xs={12}>
                                                <Grid container spacing={2} sx={{my:1, py: 2, px:2}}>
                                                    <Grid item md={12} lg={1} sx={{p: '0 !important'}}>
                                                        <Avatar variant='square' sx={{ bgcolor: 'primary.main', borderRadius: 1 }} >{user&&user.fullname[0]}</Avatar>
                                                    </Grid>
                                                    <Grid item md={12} lg={10} sx={{p: '0 !important', marginLeft: '1rem'}}>
                                                        <Typography sx={{py:1}} variant='subtitle1'>{postedQuestion}</Typography>
                                                    </Grid>
                                                </Grid>
                                                <Grid container spacing={2} sx={{my:1, py: 2, px:2}}>
                                                    <Grid item md={12} lg={1} sx={{p: '0 !important'}}>
                                                        <img height='35px' width='35px' alt="logo" src={chatlogo}  />
                                                    </Grid>
                                                    <Grid item md={12} lg={10} sx={{p: '0 !important', marginLeft: '1rem'}}>
                                                        <Box>
                                                        <div class="markupTable" dangerouslySetInnerHTML={{ __html: remark.render(streamedAnswer) }} ></div>
                                                        </Box>
                                                        <LinearProgress sx={showChatLoader?null:{display:'none'}} />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>}
                                    </>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container spacing={0} position='relative' sx={{marginTop:'30px'}}>
                                        <Grid item xs={11} position='absolute' bottom={50} sx={{width:'100%'}}>
                                            {(!activeChatId && !postedQuestion) ? <Box display='flex' flexDirection='column'>
                                               {faqs?.length>0 && <Typography fontWeight='bold' sx={{opacity:0.5,marginBottom:'0.8rem'}}>FAQs</Typography>}
                                                <Grid display='flex' justifyContent='space-between' container spacing={2}     sx={{minWidth:'100% !important' }}>
                                                {faqs?.length>0&&faqs.map((item,index)=>{                   
                                                    return <Grid onMouseEnter={()=>setHoveredFaq(item)} onMouseLeave={()=>{setHoveredFaq(null)}} onClick={()=>{handleFAQQuestion(item)}} sx={{cursor: 'pointer'}} key={`faqs`+index} item xs={6}>
                                                            <Box display='flex' justifyContent='space-between' sx={{padding: '0.75rem !important',  boxShadow:2, borderRadius: 2}}>
                                                                <Tooltip title={item}><Typography sx={{textOverflow: 'ellipsis', overflow: 'hidden', width: "75%"}} noWrap >{item}</Typography></Tooltip>
                                                                {hoveredFaq===item&&<Send sx={{float:'right', opacity: 0.5}} />}
                                                            </Box>
                                                        </Grid>                                                      
                                                })}
                                                </Grid>
                                            </Box>
                                            :                                         
                                            <Grid>
                                                {faqs?.length>0&&<PopupState variant="popover">
                                                    {(popupState) => (
                                                        <>
                                                            <Button size='small' sx={{ textTransform: 'capitalize' }} {...bindTrigger(popupState)} variant='contained' color='primary'>{!popupState.isOpen ? <KeyboardDoubleArrowUp sx={{mr: 1}} /> : <KeyboardDoubleArrowDown sx={{mr: 1}} />}FAQs</Button>
                                                            <Popover {...bindPopover(popupState)} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} sx={{padding: '1rem', width: '50%'}}>
                                                                <Typography sx={{color: muiTheme&&muiTheme.palette.mode==='dark'?"#FFFFFF": 'primary.main', py: 2, px:1, borderBottom: '1px solid'}} fontWeight='bold'>Frequently Asked Questions</Typography>
                                                                {faqs?.length>0&&faqs.map((item,index)=>{
                                                                    return <Typography onClick={()=>{handleFAQQuestion(item); popupState.close()}} sx={{paddingY: '0.75rem !important', borderBottom: '1px solid', color: muiTheme&&muiTheme.palette.mode==='dark'?"#FFFFFF": 'primary.main', cursor: 'pointer', width: '95%', margin: 'auto'}} key={`colfaqs`+index}>{item}</Typography>
                                                                })}
                                                            </Popover>
                                                        </>
                                                        )}
                                                </PopupState>}
                                            </Grid>
                                            }
                                        </Grid>
                                        <Grid item xs={11} >
                                            <TextField value={query} onKeyUp={(e)=>e.keyCode === 13&&handlePostQuestion()} onChange={(e)=>setQuery(e.target.value)} size='small' label="Ask your Query" variant="outlined" fullWidth
                                                InputProps={{
                                                    endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton onClick={()=>handlePostQuestion()}>
                                                        <Send />
                                                        </IconButton>
                                                    </InputAdornment>
                                                    )
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={11}>
                                    <Typography  fontSize={'10px'} variant='subtitle2' sx={{float: 'right'}}>{appConfigs.footerText}</Typography>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                </Grid>
                <Dialog fullWidth open={showThreadEdit} TransitionComponent={Transition} keepMounted onClose={()=>handleThreadEdit()}>
                    <DialogTitle>Edit Thread Name</DialogTitle>
                    <DialogContent>
                        <Box sx={{marginTop: '1rem'}}>
                            <TextField inputProps={{ maxLength: appConfigs.threadCharCount }} fullWidth  label="Thread Name" variant="outlined" value={threadName} onChange={(e)=>{setThreadName(e.target.value); setThreadCharCount(appConfigs.threadCharCount - e.target.value.length)}} />
                            <Typography variant="caption" color='grey'>{threadCharCount !== appConfigs.threadCharCount ? `${threadCharCount} characters remaining.` : `Maximum ${appConfigs.threadCharCount} characters are allowed.`}</Typography>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button sx={{ textTransform: 'capitalize' }} variant='outlined' color='primary' onClick={()=>handleThreadEdit()}>Cancel</Button>
                        <Button sx={{ textTransform: 'capitalize' }} variant='contained' color='primary' disabled={!(selectedThread&&(threadName.length <= appConfigs.threadCharCount && threadName.trim() && threadName.trim() !== selectedThread.threadName))} onClick={()=>handleEditSubmit()}>Save</Button>
                    </DialogActions>
                </Dialog>
                <Dialog fullWidth open={showThreadDelete} TransitionComponent={Transition} keepMounted onClose={()=>handleThreadDelete()}>
                    <DialogTitle>Delete Thread</DialogTitle>
                    <DialogContent>
                        <Typography variant='body2'>Are you sure you want to delete this Thread?</Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button sx={{ textTransform: 'capitalize' }} variant='outlined' color='primary' onClick={()=>handleThreadDelete()}>Cancel</Button>
                        <Button sx={{ textTransform: 'capitalize' }} variant='contained' color='primary' onClick={()=>handleDeleteSubmit()}>Delete</Button>
                    </DialogActions>
                </Dialog>
                <Dialog fullWidth open={showFeedbackPop} TransitionComponent={Transition} keepMounted onClose={()=>handleFeedbackToggle()}>
                    <DialogTitle>
                        {feedback===0&&"Withdraw Feedback"}
                        {feedback===1&&"Provide Feedback"}
                        {feedback===2&&"Provide Feedback"}
                    </DialogTitle>
                    <DialogContent>
                        {feedback===0&&<Typography variant='body2'>Are you sure you want to withdraw the provided feedback?</Typography>}
                        {feedback===1&&<Box>
                                <Typography  variant='body2' sx={{ marginBottom: 2 }}>We are happy that we are able to assist you. Please leave us a comment.</Typography>
                                <TextField inputProps={{ maxLength: appConfigs.feedbackCharCount }} fullWidth label="Feedback" value={feedbackComment} multiline maxRows={4} onChange={(e)=>{setFeedbackComment(e.target.value); setFeedbackCharCount(appConfigs.feedbackCharCount - e.target.value.length)}}/>
                                <Typography variant='caption' color='grey'>{feedbackCharCount !== appConfigs.feedbackCharCount ? `${feedbackCharCount} characters remaining.` : `Maximum ${appConfigs.feedbackCharCount} characters are allowed.`}</Typography>
                                <Typography sx={{my: 1}} fontWeight='bold' variant='body2'>Please Select Category</Typography>
                                <Grid container spacing={1}>
                                    {appConfigs.positiveFeedbackCategories.map((cat)=>{
                                        return <Grid key={cat} item xs={12} md={6}>
                                            <Chip onClick={()=>{setFeedbackCategory(cat)}} variant={feedbackCategory===cat ? 'solid' : 'outlined'} label={cat} />
                                        </Grid>
                                    })}
                                </Grid>
                            </Box>
                        }
                        {feedback===2&&<Box>
                                <Typography  variant='body2' sx={{ marginBottom: 2 }}>We are sorry about this. Please let us know us what went wrong, we will rectify.</Typography>
                                <TextField inputProps={{ maxLength: appConfigs.feedbackCharCount }} fullWidth label="Feedback" value={feedbackComment} multiline maxRows={4} onChange={(e)=>{setFeedbackComment(e.target.value); setFeedbackCharCount(appConfigs.feedbackCharCount - e.target.value.length)}}/>
                                <Typography variant='caption' color='grey'>{feedbackCharCount !== appConfigs.feedbackCharCount ? `${feedbackCharCount} characters remaining.` : `Maximum ${appConfigs.feedbackCharCount} characters are allowed.`}</Typography>
                                <Typography sx={{my: 1}} fontWeight='bold' variant='body2'>Please Select Category</Typography>
                                <Grid container spacing={1}>
                                    {appConfigs.negativeFeedbackCategories.map((cat)=>{
                                        return <Grid key={cat} item xs={12} md={6}>
                                            <Chip onClick={()=>{setFeedbackCategory(cat)}} variant={feedbackCategory===cat ? 'solid' : 'outlined'} label={cat} />
                                        </Grid>
                                    })}
                                </Grid>
                            </Box>
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button sx={{ textTransform: 'capitalize' }} variant='outlined' color='primary' onClick={()=>handleFeedbackToggle()}>Cancel</Button>
                        <Button disabled={!feedbackCategory && feedback!==0}  sx={{ textTransform: 'capitalize' }} variant='contained' color='primary' onClick={()=>{handleFeedbackSubmit()}}>Submit</Button>
                    </DialogActions>
                </Dialog>
                <Dialog fullWidth fullScreen open={showDocumentViewer} TransitionComponent={Transition} keepMounted onClick={()=>{setShowDocumentViewer(false); setDocumentObject(null);}}>
                    <DialogTitle>
                        <IconButton
                        onClick={()=>{setShowDocumentViewer(false); setDocumentObject(null);}}
                        sx={{ color: "#000000", float: 'right'}} >
                        <Close />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <DocViewer link={documentObject} downloadable={appConfigs.allowDocDownload} />
                    </DialogContent>
                    <DialogActions>
                        <Button sx={{ textTransform: 'capitalize' }} variant='outlined' color='primary' onClick={()=>{setShowDocumentViewer(false); setDocumentObject(null);}}>Close</Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </PageLayout>
    );
}